export type PostPhoto = {
  id: string,
  name?: string,
  url: string,
};

export type Post = {
  id: string, 
  creatorName: string, 
  subject: string, 
  updatedAt: string, 
  createdAt: string, 
  body: string, 
  liked: number, 
  likesCount: number, 
  replies: Post[], 
  creatorId: string, 
  replyToName?: string, 
  replyToId?: string, 
  replyTo?: string, 
  picFolderId?: string,
  photos?: PostPhoto[], 
};
export const emptyPost = {
  id: "", 
  creatorName: "", 
  creatorEmail: "", 
  subject: "", 
  updatedAt: "", 
  createdAt: "", 
  body: "", 
  liked: 0, 
  likesCount: 0, 
  replies: [],  
  creatorId: "", 
  picFolderId: "",
  photos: [],
};
